"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _leafletGeosearch = require("leaflet-geosearch");

var _MapWithPins = _interopRequireDefault(require("../MapWithPins"));

var _config = _interopRequireDefault(require("../../config"));

var _debounce = require("../../utils/debounce");

var _antd = require("antd");

require("./style.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var provider = _config.default.GOOGLE_MAPS_KEY ? new _leafletGeosearch.GoogleProvider({
  params: {
    key: _config.default.GOOGLE_MAPS_KEY
  }
}) : new _leafletGeosearch.OpenStreetMapProvider({});
var SEARCH_DEBOUNCE = 500; // 0.5 seconds

var DEFAULT_LAT = 40.4083539;
var DEFAULT_LON = -3.692422;
var DEFAULT_ZOOM = 18;

var CustomAddressSearch = function CustomAddressSearch(_ref) {
  var intl = _ref.intl,
      _ref$organization = _ref.organization,
      organization = _ref$organization === void 0 ? {} : _ref$organization,
      addressValue = _ref.addressValue,
      latitude = _ref.latitude,
      longitude = _ref.longitude,
      onChangeLocation = _ref.onChangeLocation,
      error = _ref.error,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Search...' : _ref$placeholder,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? null : _ref$label;

  var _useState = (0, _react.useState)({
    latitude: latitude || organization.default_latitude || DEFAULT_LAT,
    longitude: longitude || organization.default_longitude || DEFAULT_LON,
    zoom: DEFAULT_ZOOM,
    text: ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  (0, _react.useEffect)(function () {
    // Monkey patching FTW
    // This only works on Google Maps
    var params = provider.options.params;
    provider.options.params = _objectSpread(_objectSpread({}, params), {}, {
      region: organization.region || ''
    });
  }, [organization]);

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      results = _useState4[0],
      setResults = _useState4[1];

  var doChooseAddress = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(result) {
      var _JSON$parse, x, y, _label, newPosition;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                _JSON$parse = JSON.parse(result), x = _JSON$parse.x, y = _JSON$parse.y, _label = _JSON$parse.label;
                newPosition = _objectSpread(_objectSpread({}, position), {}, {
                  latitude: y,
                  longitude: x,
                  text: _label
                });
                setPosition(newPosition);
                onChangeLocation(newPosition);
              } catch (err) {}

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function doChooseAddress(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var doSearch = (0, _react.useMemo)(function () {
    return /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(query) {
        var results;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (query) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return provider.search({
                  query: query
                });

              case 4:
                results = _context2.sent;
                setResults(results);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
  }, []);
  var onSearch = (0, _react.useMemo)(function () {
    return (0, _debounce.debounce)(doSearch, SEARCH_DEBOUNCE);
  }, [doSearch]);
  var pins = position.text ? [position] : [];
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    label: label,
    hasFeedback: true,
    validateStatus: error ? 'error' : '',
    help: error
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, {
    showSearch: true,
    value: addressValue || undefined,
    placeholder: placeholder,
    defaultActiveFirstOption: false,
    showArrow: false,
    filterOption: false,
    onSearch: onSearch,
    notFoundContent: null,
    onSelect: doChooseAddress
  }, results.map(function (r, index) {
    return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      value: JSON.stringify(r),
      key: index
    }, r.label);
  }))), /*#__PURE__*/_react.default.createElement(_MapWithPins.default, {
    intl: intl,
    latitude: position.latitude,
    longitude: position.longitude,
    zoom: position.zoom,
    pins: pins
  }));
};

var _default = CustomAddressSearch;
exports.default = _default;